
import { onMounted, reactive, computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import {  sendMessageToFlutter,showRulesMethod } from '@/api/api'
import Spinner from '@/components/transitions/Spinner.vue'
import MaskLayer from '@/components/share/MaskLayer.vue'
import Fade from '@/components/transitions/Fade.vue'
import { isAndroid, isIOS, toHttpsAbsolute } from '@/utils/utils'
import NoteDialog from '@/components/custom_functions/NoteDialog.vue'
import FeaturesDialog from '@/components/custom_functions/FeaturesDialog.vue'
export default {
    name: "CustomFunctions2",
    components: {
        Spinner,
        MaskLayer,
        Fade,
        NoteDialog,
        FeaturesDialog
    },
    setup() {
        const store = useStore()
        const local = computed(() => store.state.translation.locale)
        const showNote = computed(() => {
            return store.state.customFeatures.showAdsRulesStatus
        })
        const route = useRoute()
        const state = reactive({
            showLoading: false,
            loadingFeatures: false,
            catigurySelected: false,
            showFeatureDialog: true
        })

        const openNote = () => {
            showRulesMethod(JSON.stringify({method: "showAdsRules"}))
        }

        const closeNote  = () => {
            store.dispatch('customFeatures/setAdsRules',false)
        }

        const getAgentType = computed(()=> {
            if(isAndroid()) return 1;
            else if(isIOS()) return 2;
            else return 0
        })
        // -------------------------------------------------------------------------------------------
        onMounted(async () => {
            await store.dispatch(`translation/getLangs`, { userLang: route.query.lang ?? 'cn' })
        });

        function toggleComponent(name: string) {
            if (name in state) {
                state[name] = !state[name]
            }
        }

        function closeTab_() {
            sendMessageToFlutter('clickBack')
        }

        const closeComponent = (name: string) => {
            if (name in state) {
                state[name] = false
            }
        }

        const openComponent = (name: string) => {
            if (name in state) {
                state[name] = true
            }
        }

        return {
            state,
            toggleComponent,
            local,
            closeComponent,
            openComponent,
            closeTab_,
            getAgentType,
            toHttpsAbsolute,
            openNote,
            closeNote,
            showNote,
            showRulesMethod
        }
    }
}

